const MAX_Y_AXIS_TICK_COUNT = 6;
export const MAX_Y_AXIS_SPLIT_COUNT = MAX_Y_AXIS_TICK_COUNT - 1;

const getNiceInterval = (value: number): number => {
  if (!Number.isFinite(value) || value <= 0) {
    return 1;
  }
  const exponent = Math.floor(Math.log10(value));
  const base = 10 ** exponent;
  const normalized = value / base;
  if (normalized <= 1) {
    return base;
  }
  if (normalized <= 2) {
    return 2 * base;
  }
  if (normalized <= 5) {
    return 5 * base;
  }
  return 10 * base;
};

export const getYAxisScaleLimit = (
  seriesList: any[],
): {
  min: number;
  max: number;
  interval: number;
  splitNumber: number;
} | null => {
  if (!Array.isArray(seriesList) || !seriesList.length) {
    return null;
  }
  const values: number[] = [];
  seriesList.forEach((seriesItem) => {
    const dataList = seriesItem?.data;
    if (!Array.isArray(dataList)) {
      return;
    }
    dataList.forEach((item) => {
      const rawValue =
        item && typeof item === 'object' && 'value' in item
          ? item.value
          : item;
      const value = Number(rawValue);
      if (Number.isFinite(value)) {
        values.push(value);
      }
    });
  });
  if (!values.length) {
    return null;
  }
  let min = Math.min(...values, 0);
  let max = Math.max(...values, 0);
  if (min === max) {
    const delta = min === 0 ? 1 : Math.abs(min) * 0.2;
    min -= delta;
    max += delta;
  }
  let interval = getNiceInterval((max - min) / MAX_Y_AXIS_SPLIT_COUNT);
  let axisMin = Math.floor(min / interval) * interval;
  let axisMax = Math.ceil(max / interval) * interval;
  let tickCount = Math.round((axisMax - axisMin) / interval) + 1;
  let guard = 0;
  while (tickCount > MAX_Y_AXIS_TICK_COUNT && guard < 10) {
    interval = getNiceInterval(interval * 1.5);
    axisMin = Math.floor(min / interval) * interval;
    axisMax = Math.ceil(max / interval) * interval;
    tickCount = Math.round((axisMax - axisMin) / interval) + 1;
    guard += 1;
  }
  return {
    min: axisMin,
    max: axisMax,
    interval,
    splitNumber: Math.max(
      1,
      Math.min(MAX_Y_AXIS_SPLIT_COUNT, tickCount - 1),
    ),
  };
};
